import { render, staticRenderFns } from "./SectionIconsDescriptions.vue?vue&type=template&id=2df642f7&"
import script from "./SectionIconsDescriptions.vue?vue&type=script&lang=js&"
export * from "./SectionIconsDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./SectionIconsDescriptions.vue?vue&type=style&index=0&id=2df642f7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MoleculesCommonMoleculeIconListWithTexts: require('/app/components/molecules/common/MoleculeIconListWithTexts.vue').default})
